import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { ImageRecognitionReport } from './Pages'

export const ImageRecognitionReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={ImageRecognitionReport} />
    </Fragment>
)